module.exports = __webpack_public_path__ + "img/akwhite.87b4444e.png";